/**
 * CPC mobile menu: show "Shop" already open on the first screen
 *
 * Horizon's mobile drawer puts 3-level menus behind a drill-down ("Shop ›", then a new panel).
 * This moves the first top-level item's contents (Shop by Car / Shop by Brand / Maintenance & Track Prep)
 * straight into the main drawer list, so shoppers see the categories as soon as they open the menu,
 * without tapping "Shop". The other top-level links (Our Builds, About Us, FAQs, Contact) stay below it.
 *
 * Horizon can re-render the header after the page loads, so this re-applies itself whenever the
 * drawer markup changes or the menu button is tapped. It only ever changes the drawer once per render.
 *
 * It also adds the trust points (Content > Metaobjects > Menu trust point) to the empty space at the
 * bottom of the drawer. Their markup is rendered in a <template> in snippets/cpc-custom-styles.liquid.
 *
 * Loaded from snippets/cpc-custom-styles.liquid. Styles live in the same snippet.
 */
(() => {
  const EXPANDED_FLAG = 'cpcShopExpanded';

  function expandFirstMenu() {
    const lists = document.querySelectorAll('header-drawer .menu-drawer__menu.has-submenu');

    lists.forEach((list) => {
      if (list.dataset[EXPANDED_FLAG]) return;

      const container = list.querySelector(':scope > .menu-drawer__list-item > details.menu-drawer__menu-container');
      if (!container) return;

      const item = container.parentElement;
      const summaryText = container.querySelector(':scope > summary .menu-drawer__menu-item-text');
      const childList = container.querySelector('.menu-drawer__menu--childlist');
      if (!item || !childList) return;

      const title = document.createElement('p');
      title.className = 'cpc-drawer-shop__title menu-drawer__menu-item menu-drawer__menu-item--mainlist';
      title.textContent = summaryText ? summaryText.textContent.trim() : 'Shop';

      childList.classList.add('cpc-drawer-shop__list');
      childList.removeAttribute('tabindex');

      list.dataset[EXPANDED_FLAG] = 'true';
      item.classList.add('cpc-drawer-shop');
      item.replaceChildren(title, childList);
    });
  }

  function addTrustPoints() {
    const template = document.getElementById('CpcDrawerTrustPoints');
    if (!(template instanceof HTMLTemplateElement)) return;

    document.querySelectorAll('header-drawer .menu-drawer').forEach((drawer) => {
      if (drawer.querySelector(':scope > .cpc-drawer-usps')) return;

      const nav = drawer.querySelector(':scope > .menu-drawer__navigation');
      if (!nav) return;

      nav.after(template.content.cloneNode(true));
    });
  }

  function enhanceDrawer() {
    expandFirstMenu();
    addTrustPoints();
  }

  function watchHeader() {
    const header = document.getElementById('header-group') || document.querySelector('header-component');
    if (!header) return;
    new MutationObserver(enhanceDrawer).observe(header, { childList: true, subtree: true });
  }

  enhanceDrawer();

  document.addEventListener('DOMContentLoaded', () => {
    enhanceDrawer();
    watchHeader();
  });

  window.addEventListener('load', enhanceDrawer);

  // Re-apply just before the drawer opens, in case the header was re-rendered
  document.addEventListener(
    'click',
    (event) => {
      if (event.target instanceof Element && event.target.closest('.header__icon--menu')) enhanceDrawer();
    },
    true
  );

  // Theme editor: re-apply when the header section is re-rendered
  document.addEventListener('shopify:section:load', enhanceDrawer);
})();
